/* Import Leverege Modules */
import { GlobalState } from '@leverege/ui-redux';
import { Toast } from '@leverege/ui-elements';

/* Import Local Modules */
import { LOCATOR_SKUS, BEACON_SKUS } from '../../constants';

/**
 * Uploads locator/beacon shipment/manufacturing log.
 */
async function upload(options) {
  // Get parameters
  const {
    logType,
    sku,
    file,
    actions,
    onChange,
    onClose,
    goToJobs = false,
    throwErr = false,
    toast = true,
    revert = false,
    sampleAlias,
    simOptions
  } = options;
  const {
    locationId
  } = actions?.match?.params || {};

  // Optionally update loading state
  onChange?.({
    data: 'loading',
    value: true
  });

  // Send request to server
  await GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    try {
      const skuType = LOCATOR_SKUS.map(entry => entry.value).includes(sku) || sku === 'locator' ? 'locatorSku' : BEACON_SKUS.map(entry => entry.value).includes(sku) || sku === 'beacon' ? 'beaconSku' : null;
      const useKDS = window.Molten.getConfig('genericLogUpload') || !skuType;
      const route = useKDS ? `${process.env.IMAGINE_HOST}/v1/project/${process.env.PROJECT_ID}/system/${process.env.SYSTEM_ID}/srv/kudelskidevice/imagineGroup/${locationId}/sku/${sku}/log/${logType}` :
      // eslint-disable-line max-len
      `${process.env.IMAGINE_HOST}/v1/interface/${process.env.SYSTEM_ID}/location/${locationId}.srv/recovrLogUpload/${skuType}/${sku}/log/${logType}`; // eslint-disable-line max-len
      const headers = {
        Authorization: api?.getToken()
      };
      const body = new FormData();
      body.append('csv', file, 'file');
      if (simOptions?.hasSimSku && !revert) {
        body.append('simOptions', JSON.stringify(simOptions));
      }
      if (sampleAlias) {
        body.append('sampleAlias', sampleAlias);
      }
      const method = revert ? 'DELETE' : 'POST';
      const {
        message,
        headerMessage
      } = await fetch(route, {
        method,
        credentials: 'include',
        headers,
        body,
        redirect: 'follow'
      }) // eslint-disable-line max-len
      .then(async res => {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        }
        const errJson = await res.json();
        const err = new Error(errJson?.message);
        err.status = res.status;
        throw err;
      });
      if (toast) {
        if (message.includes('failed')) {
          Toast.error([`Unable to ${revert ? 'revert' : 'upload'} ${logType} log`, message]);
        } else {
          Toast.success(`${revert ? `Reverting ${logType} log` : headerMessage ? `Uploading ${logType} log. ${headerMessage}` : `Uploading ${logType} log.`}`);
        }
      } // eslint-disable-line max-len
    } catch (err) {
      console.error(err);
      if (toast) {
        Toast.error([`Unable to ${revert ? 'revert' : 'upload'} ${logType} log`, err?.message]);
      }
      if (throwErr) {
        throw err;
      }
    }

    // Update close
    onClose?.();

    // Go to jobs page
    if (goToJobs) {
      setTimeout(() => GlobalState.dispatch(actions.parent().parent().child('jobs').goTo()), 500);
    }
  });
}
export default {
  upload
};